__turbopack_context__.v({
  "emptyContainer": "H0wdea_emptyContainer",
  "socialMediaIconsContainer": "H0wdea_socialMediaIconsContainer",
});
